/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { bool } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import AccountService from 'cio/services/account';

type Direction = 'top' | 'top-right' | 'right' | 'bottom-right' | 'bottom' | 'bottom-left' | 'left' | 'top-left';
interface GatedFeaturesPopoverArgs {
  direction?: Direction;
}
export default class GatedFeaturesPopover extends Component<GatedFeaturesPopoverArgs> {
  @service account!: AccountService;

  @bool('account.current.suspendTrialAt') isEssentialsTrial!: boolean;

  @action
  handleCtaClick(popoverClose: () => unknown, ctaTrigger: () => unknown) {
    popoverClose();
    ctaTrigger();
  }

  get direction() {
    return this.args.direction ?? 'bottom';
  }

  @action
  noop() {
    // Replaces popover.open/close functions when the popover
    // component is not rendered
  }
}
